import LanguageStats from "./LanguageStats";
export default LanguageStats;
